onReady(() => {
    function isModuleRoot(contentCard) {
        return contentCard.classList.contains("page-content") ||
            contentCard.classList.contains("ds-insights") ||
            contentCard.classList.contains("content")
    }

    function findModule(contentCard) {
        while (contentCard) {
            previousParent = contentCard;
            contentCard = contentCard.parentElement
            if (isModuleRoot(contentCard)) {
                return previousParent;
            }
        }
    }

    const contentCards = document.querySelectorAll('a.insight-content-card')
    contentCards.forEach(function (contentCard) {
        module = findModule(contentCard);
        contentCard.addEventListener('click', (event) =>
            dataLayer.push({
                event: 'card-click',
                interactionType: 'click',
                moduleName: module.dataset.moduleName,
                destinationUrl: contentCard.href,
                contentType: contentCard.dataset.contentType,
                click_text: contentCard.querySelector('.copy p').textContent,
                modulePosition: module.dataset.modulePosition,
                distinctModulePosition: module.dataset.distinctModulePosition,
                moduleTabPosition: module.dataset.tabPosition,
                moduleId: module.dataset.moduleId,
                wpLoggedIn: document.body.classList.contains('logged-in')
                    .toString(),
            }))
    })
});
